import { PostMessageEvent } from './types';
import { win } from '../win';

type UnListenMessage = () => void;

export const messenger = {
  addListener(
    messageHandler: (event: PostMessageEvent) => void,
    // used in tests to distinguish between the clients that start listening to post message
    clientName: string
  ): UnListenMessage {
    win.addEventListener('message', messageHandler);

    return () => {
      win.removeEventListener('message', messageHandler);
    };
  },
};
